import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('purchase_order_matching'),
    matchingAutoMarkingPoSubtitle: defineMessage('can_a_purchase_order_ge__to_this_purchase_order'),
    matchingAutoUnmarkingPoSubtitle: defineMessage('can_a_purchase_order_ge_ched_to_it_is_unmatched'),
    autoMarkingPoYesLabel: defineMessage('yes_if_the_purchase_ord_s_less_than_or_equal_to'),
    autoMarkingPoNoLabel: defineMessage('no_never'),
    autoUnmarkingPoYesLabel: defineMessage('yes_revoke_its_marking_as_billed'),
    autoUnmarkingPoNoLabel: defineMessage('no_never'),
};
